import { showToast } from "@/lib/toast";

export const getReferralLinks = (userEmail) => {
  const referralUrl = `${process.env.NEXT_PUBLIC_BASE_URL}/r/${userEmail}`;
  const message = `Hi, I’m inviting you to join SmartGuy! Sign up using this link and get $50 off your business upgrade. \n\n${referralUrl} \n\nOr, you can use my email ${userEmail} as the referral when upgrading your business to receive the $50 discount.`;

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(message)}`,
    sms: `sms:?&body=${encodeURIComponent(message)}`,
    copy: message,
  };

  return shareLinks;
};

export const openShareLink = (url) => {
  window.open(url, '_blank', 'width=600,height=400');
};

export const copyShareLink = async (message) => {
  await navigator.clipboard.writeText(message);
  showToast('Referral message and link copied to clipboard!', 'success');
};